import React from 'react';
import jmespath from 'jmespath';

const useValidateJmesPath = value => {
    const [isValid, setIsValid] = React.useState(false);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        try {
            jmespath.compile(value);
            setIsValid(true);
        } catch (error) {
            setIsValid(false);
            setError(error);
        }
        return () => {};
    }, [value]);

    return [isValid, error];
};

/**
 * Check a jmespath string's validity by trying to compile it
 * Since JmesPath will throw an error if the syntax isn't valid
 * A try catch block will handle potential errors and log them as warnings
 * @param {string} value - String input to check for JmesPath syntax validity
 * @returns {boolean} String input validity
 */
export const validateJmesPath = value => {
    try {
        return Boolean(jmespath.compile(value));
    } catch (error) {
        console.warn(error);
        return false;
    }
};

export default useValidateJmesPath;
